<template>
  <tr
    :class="['tr-group ms-tr', dataRow.IsBold ? 'ms-format-bold' : '', dataRow.IsItalic ? 'ms-format-italic' : '']"
    v-if="!dataRow.isHide"
  >
    <td v-if="multiple && isShowMultiple" class="ms-td multiple-cell sticky ms-col-td-multiple">
      <ms-checkbox
        :checked="isChecked"
        @input="checkMultiple"
        class="justify-center"
        ref="multiple"
        checkOnly
        :key="0"
      />
    </td>
    <td
      v-for="(col, index) in columnSumary"
      :key="index"
      :colspan="col.groupColspan"
      class="ms-td ms-col-td"
      :class="[index === columnSumary?.length - 1 ? 'ms-col-td-last' : '', index === 0 ? 'sticky-row-group' : '']"
    >
      <div class="flex-row" :class="`level-${dataRow.level}`">
        <div
          v-if="index === 0"
          class="pointer"
          :class="[dataRow.expanded ? 'expand' : 'collapse']"
          @click="toggle_click"
        ></div>
        <div :class="[`text-${col.align || 'left'}`, col.cssClass, 'text-overflow', 'content-cell text-overflow']">
          <span
            v-if="linkedGroupField"
            v-html="
              $ms.format.formatData(dataRow[col.dataField], {
                formatType: col.formatType,
                optionFormat: col.optionFormat,
                enumName: col.enum,
                isShowZero: isShowZero,
              })
            "
          >
          </span>
          <span :class="[`text-${col.align || 'left'}`]" :ref="`text-${col.dataField}`" v-else>
            {{
              $ms.format.formatData(dataRow[col.dataField], {
                formatType: col.formatType,
                optionFormat: col.optionFormat,
                enumName: col.enum,
                isShowZero: isShowZero,
              })
            }}
          </span>
        </div>
      </div>
    </td>

    <td :key="100" v-if="$slots.widget" class="ms-td widget-item sticky">
      <slot name="widget" />
    </td>
  </tr>
</template>

<script>
import { computed, watch } from 'vue';
export default {
  props: {
    linkedGroupField: {
      default: null,
      type: String,
    },
    isShowZero: {
      default: true,
      type: Boolean,
    },
    col: {
      default: () => [],
      type: Object,
    },
    columnSumary: {
      default: () => [],
      type: Array,
    },
    dataRow: {
      default: () => {},
      type: Object,
    },
    //Ẩn/hiện cột checkbox tích chọn nhiều cột
    multiple: {
      default: false,
      type: Boolean,
    },
    isShowMultiple: {
      default: false,
      type: Boolean,
    },
    isCheckedAll: {
      default: () => false,
      type: Boolean,
    },
    //Trạng thái tích chọn ở cột multiple
    isSelected: {
      default: false,
      type: Boolean,
    },
  },
  emits: ['toogleTree', 'clickMultipleGroup'],
  methods: {
    /**
     * Click checkbox
     * NXCHIEN 21.10.2022
     */
    checkMultiple(e) {
      const me = this;
      const checked = e.target.tagName.toLowerCase() === 'input' ? e.target.checked : false;
      this.$emit('clickMultipleGroup', this.dataRow, checked);
    },
  },
  setup(props, { emit }) {
    const toggle_click = () => {
      emit('toogleTree', props.dataRow);
    };

    /**
     * Nếu có check all sẽ thực hiện check all
     */
    const isChecked = computed(() => {
      return props.isCheckedAll || props.isSelected;
    });

    return { toggle_click, isChecked };
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/MsTrViewer.scss';
.ms-format-bold {
  font-weight: $font-weight-bold;
}
.ms-format-italic {
  font-style: italic;
}

.tr-group {
  ::deep(.widget-container) {
    display: none;
  }
}

.pointer {
  height: 24px;
  width: 24px;
  position: relative;
  margin-right: 6px;
  &.expand {
    &:before {
      content: '';
      background: transparent url($ms-image-sprites) no-repeat;

      position: absolute;
      top: 0;
      left: 0;
      height: 24px;
      width: 24px;
      background-position: -336px -49px;
    }
  }

  &.collapse {
    &:before {
      content: '';
      background: transparent url($ms-image-sprites) no-repeat;

      position: absolute;
      top: 0;
      left: 0;
      height: 24px;
      width: 24px;
      background-position: -336px -121px;
    }
  }
}
.content-cell {
  line-height: 24px !important;
}
</style>
